import Cookies from "js-cookie";

import FacebookConversionRepository from "repositories/FacebookConversionRepository";

export const storeTestEventCode = () => {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.searchParams);

  if (!searchParams.has("test_event_code")) return;

  const in30min = 1 / 48;
  Cookies.set("test_event_code", searchParams.get("test_event_code"), { expires: in30min });
};

export const trackCompleteRegistration = (currentUser, url) => {
  FacebookConversionRepository.post(currentUser, {
    event_name: "CompleteRegistration",
    event_source_url: url,
  });
};
